import Random from './random'

export const SeededBottt = (seed: string) => {
  const options = {}
  const keys = [...configsKeys]

  const random = new Random(seed)

  keys.map((value, index) => Object.assign(
    options,
    {
      [value]: random.pickone(configs[value]),
    },
  ))

  return options
}

const configs = {
  // color: [
  //   'Black',
  //   'White',
  //   'Red050',
  //   'Red100',
  //   'Red200',
  //   'Red300',
  //   'Red400',
  //   'Red500',
  //   'Red600',
  //   'Red700',
  //   'Red800',
  //   'Red900',
  //   'RedA100',
  //   'RedA200',
  //   'RedA300',
  //   'RedA400',
  //   'Pink500',
  //   'Purple500',
  //   'DeepPurple500',
  //   'Indigo500',
  //   'Blue500',
  //   'LightBlue500',
  //   'Cyan500',
  //   'Teal500',
  //   'Green500',
  //   'LightGreen500',
  //   'Lime500',
  //   'Yellow500',
  //   'Amber500',
  //   'Orange500',
  //   'DeepOrange500',
  //   'Brown500',
  //   'BlueGrey050',
  //   'BlueGrey100',
  //   'BlueGrey200',
  //   'BlueGrey300',
  //   'BlueGrey400',
  //   'BlueGrey500',
  //   'BlueGrey600',
  //   'BlueGrey700',
  //   'BlueGrey800',
  //   'BlueGrey900',
  // ],
  topType: [
    'Antenna',
    'AntennaCrooked',
    'Bulb01',
    'Bulb02',
    'Horns',
    'Lights',
    'KBot',
    'Plankton',
    'Pyramid',
    'Radar',
  ],
  topColor: [
    'Red',
    'Pink',
    'Purple',
    'DeepPurple',
    'Indigo',
    'Blue',
    'LightBlue',
    'Cyan',
    'Teal',
    'Green',
    'LightGreen',
    'Lime',
    'Yellow',
    'Amber',
    'Orange',
    'DeepOrange',
    'Brown',
    'BlueGrey',
  ],
  faceType: [
    'Arturito',
    'RoboCop',
    'Round01',
    'Round02',
    'Square01',
    'Square02',
    'Square03',
    'Square04',
  ],
  faceColor: [
    'Red',
    'Pink',
    'Purple',
    'DeepPurple',
    'Indigo',
    'Blue',
    'LightBlue',
    'Cyan',
    'Teal',
    'Green',
    'LightGreen',
    'Lime',
    'Yellow',
    'Amber',
    'Orange',
    'DeepOrange',
    'Brown',
    'BlueGrey',
  ],
  textureType: [
    'None',
    'Camo01',
    'Camo02',
    'Circuits',
    'Dirty01',
    'Dirty02',
    'Dots',
    'Grunge01',
    'Grunge02',
  ],
  eyeType: [
    'Arturito',
    'Bulging',
    'Dizzy',
    'Eva',
    'Frame01',
    'Frame02',
    'Glow',
    'Hal',
    'Happy',
    'Hearts',
    'RoboCop',
    'Round',
    'RoundFrame01',
    'RoundFrame02',
    'Sensor',
    'Shade',
  ],
  mouthType: [
    'Arturito',
    'Bite',
    'Diagram',
    'Grill01',
    'Grill02',
    'Grill03',
    'RoboCop',
    'Smile01',
    'Smile02',
    'Square01',
    'Square02',
  ],
  sideType: [
    'Square',
    'Antenna01',
    'Antenna02',
    'Cables01',
    'Cables02',
    'Round',
    'SquareAsymmetric',
  ],
  sidesColor: [
    'Red',
    'Pink',
    'Purple',
    'DeepPurple',
    'Indigo',
    'Blue',
    'LightBlue',
    'Cyan',
    'Teal',
    'Green',
    'LightGreen',
    'Lime',
    'Yellow',
    'Amber',
    'Orange',
    'DeepOrange',
    'Brown',
    'BlueGrey',
  ],
}

const configsKeys = Object.keys(configs)



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/SeededBottt.tsx